import { initializeApp } from 'firebase/app'

const firebaseConfig = {
	apiKey: 'AIzaSyDfaCL53O1HLKrP7UVJIxgMTJurelYhtls',
	authDomain: window.location.host,
	projectId: 'adoc-webapp',
	storageBucket: 'adoc-webapp.appspot.com',
	messagingSenderId: '976024566777',
	appId: '1:976024566777:web:9741790e056c4322215b28',
	measurementId: 'G-Q9CP9FE3Y1',
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
export default firebaseApp
